import script from "./DressScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./DressScreen.vue?vue&type=script&setup=true&lang=js"

import "./DressScreen.vue?vue&type=style&index=0&id=54728008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54728008"]])

export default __exports__